﻿window.mcb.utilities.logTarget.render();

import { } from './elements/navigation-global.js';
import { } from './elements/driftstatus.js';
import { } from './elements/force-matching-widths.js';
import { } from './elements/link-painter.js';
import { } from './elements/mobile-accordion.js';
import { } from './elements/cookie-checker.js';
import { } from './elements/page-navigation.js';
import { } from './hotfixes/hotfixes.js';
